<template>
    <div>
        <div class="m-4">
            {{ $t('add_tracker_headline') }}
        </div>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1>{{ $t('add_tracker') }}</h1>
                    <div class="task" ref="task" v-for="task in tasks">
                        <label for="tracker_identifier">{{ $t('add_tracker_identifier') }}</label>
                        <br>
                        <input id="tracker_identifier" autofocus :disabled="task.working||task.done" style="width:10em;"
                               v-on:input="input(task)" v-on:blur="blur(task)" maxlength="11"
                               class="form-control input-identifier d-inline" v-model="task.input">
                        <img class="d-inline" v-if="task.working" src="/images/labs/spinner.svg">
                        <img class="d-inline" v-if="task.done" src="/images/labs/done.svg">
                        <div class="errors-set">
                            <p v-if="task.err.includes('identifier-invalid')">{{$t('invalid_identifier')}}</p>
                            <p v-if="task.err.includes('identifier-taken')">{{$t('already_identifier')}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {HTTP} from "../http-constants"
    import $ from 'jquery';

    export default {
        name: 'add-tracker',
        data() {
            return {
                tasks: []
            }
        },
        mounted: function () {
            this.addtask();
        },
        methods: {
            input: function (task) {
                task.input = task.input.toUpperCase().replace(/[^0-9A-F]/, '').replace(/^([0-9A-F]{8})([0-9A-F]{0,2})$/, '$1-$2');
                this.blur(task);
            },
            blur: function (task) {
                if (task.working == false && task.input.match(/^[0-9A-F]{8}\-[0-9A-F]{2}$/)) {
                    task.working = true;
                    HTTP.post('/hub/api/1/devices/', {'identifier': task.input.replace(/\-/, '')})
                        .then(function (r) {
                            task.working = false;
                            task.done = true;
                            console.log(r);
                        })
                        .catch(function (error) {
                            console.log(error);
                            task.working = false
                            task.err = "identifier-invalid"
                        });
                    if ($('.task').length == (1 + this.tasks.indexOf(task))) this.addtask();
                }
            },
            addtask: function () {
                this.tasks.push({
                    'input': '',
                    'working': false,
                    'done': false,
                    'err': []
                });
            }
        }

    }
</script>
